/**
 * @license
 * Copyright 2023 Ada School
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

const importExists = import.meta.env != undefined;

export const config = {
  TZ_KEY: "ada-TZ",
  JWT_KEY: "ada-JWT",
  JWE_EXPIRATION_KEY: "ada-JWE-EXP",
  RT_KEY_JWE: "ada-RT-JWE",
  EDIT_MODE: "ada-EditMode",
  GRAPHQL_URL:
    (importExists
      ? import.meta.env.VITE_GRAPHQL_URL
      : process.env.VITE_GRAPHQL_URL) || "http://localhost:4000/graphql",
  AUTH_API_URL:
    (importExists
      ? import.meta.env.VITE_AUTH_API_URL
      : process.env.VITE_AUTH_API_URL) || "http://localhost:4000/v1/auth",
  APP_VERSION:
    (importExists ? import.meta.env.VITE_VERSION : process.env.VITE_VERSION) ||
    "1",
  FT_KEY: "ada-FT",
  VITE_APP_ENV:
    (importExists ? import.meta.env.VITE_APP_ENV : process.env.VITE_APP_ENV) ||
    "development",
  VITE_ADA_ENV:
    (importExists ? import.meta.env.VITE_ADA_ENV : process.env.VITE_ADA_ENV) ||
    "main",
  USE_LOCAL_AVATARS:
    (importExists
      ? import.meta.env.VITE_USE_LOCAL_AVATARS
      : process.env.VITE_USE_LOCAL_AVATARS) || false,
  PUBLIC_URL:
    (importExists ? import.meta.env.PUBLIC_URL : process.env.PUBLIC_URL) || "",
  APP_COMMIT_REF:
    (importExists
      ? import.meta.env.VITE_COMMIT_REF
      : process.env.VITE_COMMIT_REF) || "",
  LANGUAGE_KEY: "ada-LNG",
  RECAPTCHA_SITE_KEY:
    (importExists
      ? import.meta.env.VITE_APP_RECAPTCHA_SITE_KEY
      : process.env.VITE_APP_RECAPTCHA_SITE_KEY) ||
    "6LdeZyQrAAAAAOAyHHdTpLgUQ_rSh0OMtasCuO4G",
  USE_API_PROXY:
    (importExists
      ? import.meta.env.VITE_USE_API_PROXY
      : process.env.VITE_USE_API_PROXY) == "true",
};
